import { ReactNode } from 'react';
import { AdformButtonModel } from 'autogen/swagger/all';
import { postAdformClickTracking } from 'modules/tracking/adformClickTracking';
import IButton from 'components/Button/shared/types/button';
import CMSLinkButton from './CMSLinkButton';

export default function CMSAdformButton({
    model: { pageAction, clickTracker },
    children,
    ...restProps
}: {
    model: AdformButtonModel;
    children: ReactNode;
} & IButton) {
    if (!pageAction) return null;

    return (
        <CMSLinkButton
            action={pageAction}
            onClick={clickTracker ? () => postAdformClickTracking(clickTracker) : undefined}
            {...restProps}
        >
            {children}
        </CMSLinkButton>
    );
}
